import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'product return requests';
moduleConfig.singleItemTitle = 'product return request';
moduleConfig.url = 'product-return-requests';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Archive Selected",
        value: "Archive"
    },
    {
        displayName: "Restore Selected",
        value: "Restore"
    }
];

moduleConfig.breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/returns`,
  },
  update: {
    label: "Update",
  },
  create: {
    label: "Create",
  },
  details: {
    label: "Details",
  },
}


export default moduleConfig;